const SCALES = {
  PHRYGIAN: ['E', 'F', 'G', 'A', 'B', 'C', 'D']
};

export default SCALES;
